module.exports = __webpack_public_path__ + "img/gold_popolvuh.140e4537.jpg";